export default "/images/9a11ec04da6add625e639c03751f5f12.avif";